/* eslint jsx-a11y/anchor-is-valid: 0 */
import { Component } from 'react'
import { bool, string, instanceOf } from 'prop-types'

import Settings from '../../../../models/settings.js'
import sendTrackingEvent from '../../../utilities/sendTrackingEvent.js'
import Post from '../../../../models/Post.js'

function getPostSocialCommerce(post) {
  if (!post || !post.socialCommerceEnabled || !post.socialCommerceUrl) {
    return {
      enabled: false,
    }
  }
  let link = post.socialCommerceUrl

  if (link.indexOf('http://') !== 0 && link.indexOf('https://') !== 0) {
    link = `http://${link}`
  }

  return {
    enabled: post.socialCommerceEnabled,
    link,
    label: post.socialCommerceLabel,
    tagline: post.socialCommerceTagline,
  }
}

export default class SocialCommerce extends Component {
  static propTypes = {
    allowCookies: bool,
    className: string.isRequired,
    divClassName: string,
    enableWebAnalytics: bool,
    feedKey: string.isRequired,
    fromGate: bool,
    post: instanceOf(Post).isRequired,
    settings: instanceOf(Settings).isRequired,
  }

  static defaultProps = {
    allowCookies: true,
    divClassName: undefined,
    enableWebAnalytics: false,
    fromGate: false,
  }

  getButtonStyles() {
    const { settings } = this.props
    let finalStyles = {}

    const backgroundColor = settings.socialCommerceButtonBackgroundColor
    const borderColor = backgroundColor
    const color = settings.socialCommerceButtonColor
    const borderRadius = settings.socialCommerceButtonBorderRadius

    if (settings.socialCommerceButtonLarge) {
      const { theme } = settings
      const isSingleTheme = theme === 'single' || theme === 'single-auto'
      finalStyles.padding = isSingleTheme ? 30 : 10
      finalStyles.paddingLeft = isSingleTheme ? 50 : 15
      finalStyles.paddingRight = isSingleTheme ? 50 : 15
    }

    finalStyles = {
      ...finalStyles,
      borderColor,
      borderRadius,
      backgroundColor,
      color,
      fontFamily: settings.fontFamily,
      textAlign: 'center',
    }

    return finalStyles
  }

  trackAndRun(post, event, noRedirect) {
    const { fromGate, feedKey, allowCookies, enableWebAnalytics } = this.props
    const button = event.which || event.button
    const ctaType = fromGate ? 'standalone_cta' : 'flow_cta'
    const trackingEvent = {
      action: 'click',
      allowCookies,
      enableWebAnalytics,
      ctaType,
      eventName: 'cta_clicked',
      eventLabel: 'cta',
      eventAction: 'clicked',
      interactive: true,
      flowKey: feedKey,
      postId: post.key,
      target: 'cta',
    }
    if (ctaType === 'flow_cta') {
      trackingEvent.postPosition = post.index
    }
    sendTrackingEvent(trackingEvent)
    if (!(button > 1 || event.ctrlKey || event.metaKey || event.shiftKey)) {
      event.preventDefault()
      const socialCommerce = getPostSocialCommerce(post)
      if (fromGate || !noRedirect) {
        window.location.href = socialCommerce.link
      }
    }
  }

  render() {
    const { className, divClassName, fromGate, post, settings } = this.props
    if (settings.socialCommerceButtonPosition === 'none' && !fromGate) {
      return null
    }
    const socialCommerce = getPostSocialCommerce(post)
    let socialCommerceButton
    if (divClassName) {
      socialCommerceButton = (
        <div className={divClassName || null}>
          <a
            className={className}
            href={socialCommerce.link}
            onClick={(event) => {
              event.stopPropagation()
              this.trackAndRun(post, event)
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={this.getButtonStyles()}
          >
            {socialCommerce.label}
            {post.firstProductDetails &&
              Object.keys(post.firstProductDetails).map((detailsKey) => (
                <span
                  key={detailsKey}
                  className={`bzfy-product-details bzfy-product-details_${detailsKey}`}
                  style={{ display: 'none' }}
                >
                  {post.firstProductDetails[detailsKey]}
                </span>
              ))}
          </a>
        </div>
      )
    } else {
      socialCommerceButton = (
        <a
          className={className}
          href={socialCommerce.link}
          onClick={(event) => {
            event.stopPropagation()
            this.trackAndRun(post, event)
          }}
          onKeyDown={(e) => e.stopPropagation()}
          style={this.getButtonStyles()}
          target="_self"
        >
          {socialCommerce.label}
          {post.firstProductDetails &&
            Object.keys(post.firstProductDetails).map((detailsKey) => (
              <span
                key={detailsKey}
                className={`bzfy-product-details bzfy-product-details_${detailsKey}`}
                style={{ display: 'none' }}
              >
                {post.firstProductDetails[detailsKey]}
              </span>
            ))}
        </a>
      )
    }

    return socialCommerce.enabled ? socialCommerceButton : null
  }
}
